import {FC} from 'react';
import {termsOfUseSx} from './TermsGerman.sx';
import {Box, Typography} from '@mui/material';

export const TermsGerman: FC = () => {
    return (
        <Box sx={termsOfUseSx.root}>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT SA
            </Typography>
            <Typography variant="h2">Nutzungsbedingungen</Typography>

            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                <em>September 2026</em>
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                1 – ZWECK
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Die vorliegenden Nutzungsbedingungen (die «Nutzungsbedingungen») der AMP IT SA und/oder ihrer
                Tochtergesellschaften, Holding- oder Schwestergesellschaften («AMP IT») regeln die Nutzung der Website
                amp-it.com (die «Website») sowie die Nutzung sämtlicher von AMP IT angebotenen Anwendungen (SaaS) und
                Software (die «Anwendungen») (die Website und die Anwendungen zusammen die «Dienste»). Aus
                redaktionellen Gründen schliesst die Verwendung des Singulars den Plural mit ein und umgekehrt, und die
                Verwendung der männlichen Form schliesst die weibliche Form mit ein und umgekehrt. Durch die Nutzung der
                Website und der Anwendungen erklärt jeder Nutzer, von den vorliegenden Nutzungsbedingungen Kenntnis
                genommen und deren Inhalt vorbehaltlos akzeptiert zu haben. Jeder Nutzer wird zudem über die
                Datenschutzerklärung von AMP IT informiert. Abweichende oder von den vorliegenden Nutzungsbedingungen
                bzw. den spezifischen Allgemeinen Geschäftsbedingungen von AMP IT abweichende Bedingungen finden im
                Verhältnis zwischen AMP IT und dem Nutzer keine Anwendung.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                2 – SPEZIFISCHE ALLGEMEINE GESCHÄFTSBEDINGUNGEN VON AMP IT
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT behält sich das Recht vor, einem Nutzer im Rahmen ihrer Dienste allfällige spezifische,
                gesonderte, kumulative und/oder von den vorliegenden Nutzungsbedingungen abweichende Allgemeine
                Geschäftsbedingungen vorzulegen. Diese spezifischen Allgemeinen Geschäftsbedingungen gelten vorbehaltlos
                für das Vertragsverhältnis zwischen AMP IT und dem Nutzer.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                3 – INANSPRUCHNAHME DER DIENSTE
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Jeder Nutzer kann den öffentlichen Bereich der Website besuchen, ohne sich registrieren zu müssen. Die
                Registrierung eines Nutzers ist jedoch zwingend erforderlich, um die Anwendungen zu nutzen und die
                Dienste von AMP IT in Anspruch zu nehmen. AMP IT behält sich das Recht vor, das öffentliche Navigieren
                jederzeit zu beenden und die Registrierung der Nutzer für den Zugang zu ihren Diensten zu verlangen.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Die von AMP IT angebotenen Dienste stehen nur volljährigen und urteilsfähigen Personen sowie
                juristischen Personen offen, die in einem Handelsregister eingetragen sind oder deren Bestehen durch
                Unterlagen nachgewiesen werden kann.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Handelt es sich beim Nutzer um eine juristische Person, kann AMP IT rechtsgültig mit jeder im
                Handelsregister eingetragenen Person einzeln kommunizieren (auch wenn diese Person über eine
                Kollektivunterschrift verfügt oder keinerlei Zeichnungsberechtigung besitzt) oder mit jeder Person, die
                mit der Bearbeitung der Angelegenheit im Namen der juristischen Person betraut ist (auch wenn diese
                Person nicht im Handelsregister eingetragen ist); soweit erforderlich, gilt die Vertragsdokumentation
                mit AMP IT (einschliesslich dieser Nutzungsbedingungen) als Vollmacht der juristischen Person zugunsten
                dieser Personen.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                4 – WEISUNGEN
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT nimmt keine Weisungen von Nutzern entgegen. Sollte ein Nutzer AMP IT eine Weisung erteilen, gilt
                diese nur dann als gültig erteilt, wenn AMP IT sie akzeptiert. Ohne eine solche Annahme übernimmt AMP IT
                – auch in dringenden Fällen – keinerlei Verpflichtung gegenüber dem Nutzer.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                5 – RICHTIGKEIT DER ANGABEN UND SPÄTERE ÄNDERUNGEN
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Jeder Nutzer, der die Anwendungen nutzt, um von den Diensten von AMP IT zu profitieren, und/oder der die
                Dienste von AMP IT in Anspruch nehmen möchte, verpflichtet sich, bei der Erstellung eines Nutzerkontos
                wahrheitsgemässe Angaben sowie auf Verlangen von AMP IT allfällige Belege vorzulegen.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Jeder Nutzer ist für die bei seiner Registrierung übermittelten und in seinem Nutzerkonto gespeicherten
                Angaben verantwortlich und trägt allein die Verantwortung für deren Verwendung. Um die Dienste von AMP
                IT nutzen zu können, verpflichtet sich jeder Nutzer, die Angaben in seinem Konto stets aktuell zu
                halten. Greift AMP IT auf Dienstleistungen Dritter zurück, um die Angaben eines Nutzers zu überprüfen,
                werden die von diesem Dritten nach der Überprüfung erhobenen Daten von AMP IT verwendet und ersetzen die
                vom Nutzer erfassten Daten (zum Beispiel bei Fehlern, die im Rahmen einer Überprüfung von Daten im
                Zusammenhang mit der Rechnungsstellung oder sonstigem festgestellt werden).
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT geht davon aus, dass die von jedem Nutzer bereitgestellten Angaben und Unterlagen vollständig und
                wahrheitsgemäss sind; AMP IT ist somit nicht verpflichtet, zusätzliche Überprüfungen vorzunehmen, und
                kann sich auf die vom Nutzer bereitgestellten Angaben und Unterlagen stützen. Müssen vom Nutzer
                bereitgestellte Angaben oder Unterlagen aktualisiert werden, verpflichtet sich jeder Nutzer, seine
                Angaben umgehend zu aktualisieren. Jeder Nutzer muss sicherstellen, dass AMP IT rechtzeitig alle für die
                Erbringung ihrer Dienste erforderlichen Informationen erhält.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT kann jederzeit die von einem Nutzer erfassten Angaben überprüfen und Belege verlangen. Bei
                Nichteinhaltung der Informationspflicht kann AMP IT jederzeit das Konto eines Nutzers schliessen
                und/oder darauf verzichten, ihm Leistungen anzubieten – auf Kosten des Nutzers – und ohne jegliche
                Haftung.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT kann gegenüber einem Nutzer oder einem Dritten keinesfalls für Schäden – einschliesslich
                indirekter oder Folgeschäden, insbesondere entgangenen Gewinn, entgangene Einsparungen, Produktions-,
                Vertrags- oder Geschäftschancenverluste – haftbar gemacht werden, die im Zusammenhang mit
                unvollständigen oder fehlerhaften Angaben stehen.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                6 – ZUSAMMENARBEIT MIT AMP IT
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Jeder Nutzer verpflichtet sich, auf erste Aufforderung von AMP IT hin jede Handlung vorzunehmen und alle
                allfälligen Dokumente zu unterzeichnen, die zur Erfüllung und/oder Durchführung der Verpflichtungen von
                AMP IT erforderlich sein könnten.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                7 – KOMMUNIKATION
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Der Nutzer akzeptiert, dass jegliche Korrespondenz elektronisch übermittelt und/oder in der betreffenden
                Anwendung zur Verfügung gestellt werden kann, auch unverschlüsselt. AMP IT geht davon aus, dass die an
                jeden Nutzer und/oder an jede mit der Bearbeitung der Angelegenheit betraute Person gerichteten
                Mitteilungen diesen erreicht haben. AMP IT ist somit nicht verpflichtet, den ordnungsgemässen Erhalt
                jeder Mitteilung auf anderem Weg sicherzustellen.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Jeder Nutzer wird darüber informiert und stimmt zu, dass jegliche Kommunikation mit AMP IT von dieser im
                Rahmen der Erfüllung ihrer Verpflichtungen verwendet und/oder offengelegt werden kann. In diesem
                Zusammenhang ist AMP IT berechtigt – ohne jegliche Einschränkung –, vom Nutzer mitgeteilte
                Informationen, soweit erforderlich, an Dritte weiterzugeben. AMP IT ist im Rahmen ihrer Kommunikation
                mit Nutzern und Dritten von jeglicher allfälligen Geheimhaltungs- bzw. Sorgfaltspflicht befreit.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Um jedem Nutzer den eigenständigen Zugriff auf seine Unterlagen zu ermöglichen, kann AMP IT bestimmte,
                dem Nutzer direkt zugängliche Tools verwenden. AMP IT setzt alles daran, jederzeit den Zugang zum Konto
                jedes Nutzers und/oder die Verfügbarkeit ihrer Anwendungen/Dienste sicherzustellen, kann dies jedoch
                nicht garantieren.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT kann gegenüber einem Nutzer oder einem Dritten keinesfalls für Schäden – einschliesslich
                indirekter oder Folgeschäden, insbesondere entgangenen Gewinn, entgangene Einsparungen, Produktions-,
                Vertrags- oder Geschäftschancenverluste – haftbar gemacht werden, die insbesondere bei Offenlegung von
                Informationen, Problemen beim Zugang zu den Unterlagen und/oder bei der Zugänglichkeit der Tools,
                Anwendungen und/oder Dienste von AMP IT durch den Nutzer entstehen.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                8 – DATENSPEICHERUNG UND PAPIERLOSER BETRIEB
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT digitalisiert ihre Dienste und die Dokumentenverwaltung so weit wie möglich. Grundsätzlich werden
                alle Papierdokumente eingescannt und anschliessend vernichtet. Jeder Nutzer wird darauf hingewiesen,
                dass bei AMP IT keine Papierakten geführt werden. Übergibt ein Nutzer AMP IT Unterlagen ohne vorherige
                Aufforderung, läuft er Gefahr, dass diese vernichtet werden. In jedem Fall steht es AMP IT frei,
                sämtliche einen Nutzer betreffenden Unterlagen und/oder Daten nach Ablauf einer Frist von zehn Jahren zu
                vernichten.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT kann gegenüber einem Nutzer oder einem Dritten keinesfalls für Schäden – einschliesslich
                indirekter oder Folgeschäden, insbesondere entgangenen Gewinn, entgangene Einsparungen, Produktions-,
                Vertrags- oder Geschäftschancenverluste – haftbar gemacht werden, die im Zusammenhang mit der
                Vernichtung von Daten und/oder Dokumenten stehen.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                9 – UNÜBERTRAGBARKEIT DES NUTZERKONTOS
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Jedes Nutzerkonto ist persönlich und darf ohne vorherige schriftliche Zustimmung von AMP IT keinesfalls
                an Dritte übertragen werden. Eine juristische Person kann über mehrere personenbezogene Konten (auf den
                Namen verschiedener Nutzer) verfügen. Jeder Nutzer verpflichtet sich, alle Massnahmen zu ergreifen, um
                sein Konto geheim zu halten und dessen Vertraulichkeit zu wahren. Die Vertraulichkeit eines Kontos liegt
                ausschliesslich in der Verantwortung des Nutzers, der AMP IT diesbezüglich von jeglicher Haftung
                befreit.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Jeder Nutzer ist für die Nutzung seines Kontos verantwortlich und trägt die Folgen der daraus
                resultierenden Handlungen (auch bei unbefugter Nutzung). Jeder Nutzer ist verpflichtet, AMP IT
                unverzüglich über einen Verlust des Zugangs oder eine missbräuchliche Nutzung seines Kontos zu
                informieren.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT kann gegenüber einem Nutzer oder einem Dritten keinesfalls für Schäden – einschliesslich
                indirekter oder Folgeschäden, insbesondere entgangenen Gewinn, entgangene Einsparungen, Produktions-,
                Vertrags- oder Geschäftschancenverluste – haftbar gemacht werden, die im Zusammenhang mit einer
                missbräuchlichen Nutzung eines Nutzerkontos stehen.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                10 – VERFÜGBARKEIT DER DIENSTE
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT setzt alles daran, den jederzeitigen Zugang zu ihren Diensten sicherzustellen, kann dies jedoch
                nicht garantieren. AMP IT kann gegenüber einem Nutzer oder einem Dritten keinesfalls für Schäden –
                einschliesslich indirekter oder Folgeschäden, insbesondere entgangenen Gewinn, entgangene Einsparungen,
                Produktions-, Vertrags- oder Geschäftschancenverluste – haftbar gemacht werden, die im Zusammenhang mit
                einer Nichtverfügbarkeit ihrer Dienste stehen.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                11 – SUPPORT
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Jegliche logistische Unterstützung durch AMP IT erfolgt über ihre Anwendungen. Der Nutzer hat keinen
                Anspruch auf telefonischen Support oder Support vor Ort. Dem Nutzer können besondere Kosten in Rechnung
                gestellt werden.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                12 – RECHTLICHER RAHMEN
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Jeder Nutzer ist sich bewusst, dass der schweizerische rechtliche Rahmen jederzeit einzuhalten ist.
                Jeder Nutzer ist selbst dafür verantwortlich, die Rechtmässigkeit seiner Handlungen im Rahmen der
                Nutzung der Dienste sicherzustellen. AMP IT kann gegenüber einem Nutzer oder einem Dritten keinesfalls
                für Schäden – einschliesslich indirekter oder Folgeschäden, insbesondere entgangenen Gewinn, entgangene
                Einsparungen, Produktions-, Vertrags- oder Geschäftschancenverluste – haftbar gemacht werden, die im
                Zusammenhang mit einer Verletzung des rechtlichen Rahmens durch den Nutzer stehen.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                13 – KEINE BERATUNG ODER EMPFEHLUNG UND VIRTUELLER ASSISTENT
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Jeder Nutzer erkennt an und versteht, dass AMP IT keinerlei Beratung erteilt und keine Empfehlungen
                abgibt. Jeder Nutzer ist somit allein für seine Entscheidungen bei der Inanspruchnahme der Dienste von
                AMP IT verantwortlich.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Keine auf der Website und/oder den Anwendungen bereitgestellte Information und/oder Unterlage ist als
                Empfehlung, Beratung, Aufforderung oder Anreiz zu verstehen, eine bestimmte Handlung einer anderen
                vorzuziehen.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT stellt den Nutzern einen auf künstlicher Intelligenz basierenden virtuellen Assistenten zur
                Verfügung, der den Support erleichtern und gängige Anfragen zu den Diensten beantworten soll. Der Nutzer
                wird zu Beginn jedes Gesprächs darüber informiert, dass er mit einem automatisierten System und nicht
                mit einer Person kommuniziert. Er kann jederzeit verlangen, an einen Mitarbeitenden weitergeleitet zu
                werden. Allfällige vom virtuellen Assistenten bereitgestellte Antworten werden automatisiert generiert
                und können Ungenauigkeiten enthalten. Diese Antworten stellen somit weder eine Beratung noch eine
                Empfehlung dar, und der Nutzer bleibt allein für deren Verwendung verantwortlich. Die Nutzung des
                virtuellen Assistenten ist für den Zugang zu den Diensten von AMP IT nicht verpflichtend.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                14 – ALLGEMEINER HAFTUNGSAUSSCHLUSS
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT kann gegenüber einem Nutzer oder einem Dritten keinesfalls für Schäden – einschliesslich
                indirekter oder Folgeschäden, insbesondere entgangenen Gewinn, entgangene Einsparungen, Produktions-,
                Vertrags- oder Geschäftschancenverluste – haftbar gemacht werden, die im Zusammenhang mit der Nutzung
                der Anwendungen und im Rahmen ihrer Dienste stehen, vorbehaltlich grober Fahrlässigkeit oder arglistigen
                Verhaltens gegenüber einem Nutzer.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT stellt ihren Kunden im Rahmen ihrer Leistungen Kommunikations-, Chat-, automatisierte Support-
                und Werkzeuge der künstlichen Intelligenz (KI) zur Verfügung, insbesondere um die Nutzung ihrer Dienste
                zu erleichtern, auf Anfragen der Nutzer zu antworten, Unterstützung zu bieten oder ihre Leistungen zu
                verbessern. Die mittels solcher Tools generierten Antworten oder Informationen können automatisiert
                erstellt werden und stellen nicht zwingend eine Beratung oder Empfehlung von AMP IT dar. Der Nutzer
                erkennt an, dass die von KI-Tools generierten Ergebnisse Fehler oder Ungenauigkeiten enthalten können
                und nicht ohne Überprüfung verwendet werden sollten, wenn eine wichtige Entscheidung oder Handlung davon
                abhängt. Der Nutzer befreit AMP IT von jeglicher Haftung im Zusammenhang mit der Inanspruchnahme
                automatisierter Unterstützung oder künstlicher Intelligenz, vorbehaltlich grober Fahrlässigkeit oder
                arglistigen Verhaltens gegenüber einem Nutzer.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                15 – DATENSCHUTZ
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Bei der Nutzung der Website, der Anwendungen sowie bei Kontakten mit AMP IT können Daten erhoben werden.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT verpflichtet sich, die Daten ihrer Nutzer in Übereinstimmung mit der geltenden Gesetzgebung zu
                verarbeiten. Jeder Nutzer wird jedoch darüber informiert, dass bestimmte von AMP IT erhobene Daten (i)
                der Verwaltung seines persönlichen Kontos dienen, (ii) an Dritte weitergegeben werden können, soweit
                dies für die Erbringung der Dienste und die Nutzung der Anwendungen unerlässlich ist, (iii) zum Versand
                von Werbung und zielgerichteten Angeboten dienen oder (iv) zum Zweck des Forderungseinzugs dienen.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Im Rahmen dieser Dienste kann AMP IT auf Kommunikations-, Chat-, automatisierte Support- und Werkzeuge
                der künstlichen Intelligenz (KI) zurückgreifen, insbesondere um die Nutzung ihrer Dienste zu
                erleichtern, auf Anfragen der Nutzer zu antworten, Unterstützung zu bieten oder ihre Leistungen zu
                verbessern. Sie kann die vom Nutzer mitgeteilten Informationen verarbeiten, soweit dies für die
                Erbringung und Verbesserung ihrer Leistungen erforderlich ist. AMP IT kann Personendaten bearbeiten.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Der Nutzer verpflichtet sich, über den Chat oder jedes von AMP IT zur Verfügung gestellte KI-Tool nur
                die für die Nutzung des Dienstes und seine Bedürfnisse erforderlichen Daten mitzuteilen. Er verpflichtet
                sich, keine besonders schützenswerten Personendaten, vertraulichen Daten oder Informationen einzugeben,
                deren Mitteilung an ein solches Tool untersagt wäre oder besondere Massnahmen erfordern würde, sofern
                AMP IT nicht ausdrücklich etwas anderes angibt.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Soweit KI-Tools oder Dienstleister Dritter zur Erbringung der Dienste eingesetzt werden, können
                bestimmte Daten durch diese Dienstleister verarbeitet werden, gegebenenfalls auch im Ausland. AMP IT
                stellt sicher, dass jede Bearbeitung von Personendaten in Übereinstimmung mit den anwendbaren
                gesetzlichen Anforderungen erfolgt. Der Nutzer kann jederzeit die Datenschutzerklärung von AMP IT
                einsehen.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                16 – ÄNDERUNG DER NUTZUNGSBEDINGUNGEN
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT behält sich das Recht vor, die vorliegenden Nutzungsbedingungen jederzeit zu ändern. AMP IT
                informiert die Nutzer darüber per E-Mail oder Benachrichtigung. Erhebt der Nutzer innerhalb von zehn
                (10) Tagen nach dieser Mitteilung keinen Einspruch, gelten die geänderten Nutzungsbedingungen als
                akzeptiert. Jeder Nutzer ist verpflichtet, sich über die jeweils geltenden Nutzungsbedingungen zu
                informieren. Im Streitfall gelten die zum jeweiligen Zeitpunkt geltenden Nutzungsbedingungen. Wurde mit
                einem Nutzer zu einem bestimmten Zeitpunkt ein Vertragsverhältnis begründet, richtet sich dieses
                Verhältnis nach den zum Zeitpunkt seines Abschlusses geltenden Nutzungsbedingungen, vorbehaltlich der
                Anwendung spezifischer oder späterer Allgemeiner Geschäftsbedingungen.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                17 – GEISTIGES EIGENTUM
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Sämtliche Rechte des geistigen Eigentums an den Diensten sowie an der Dokumentation zu den erbrachten
                Dienstleistungen verbleiben ausschliessliches Eigentum von AMP IT. Jede Vervielfältigung ist untersagt
                und kann strafrechtlich verfolgt werden.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                18 – ANWENDBARES RECHT
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Jeder mit AMP IT geschlossene Vertrag und jede Beziehung zu AMP IT sowie die vorliegenden
                Nutzungsbedingungen unterliegen ausschliesslich materiellem schweizerischem Recht.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Vorbehaltlich zwingender Gerichtsstände werden sämtliche Streitigkeiten, Meinungsverschiedenheiten oder
                Ansprüche, die sich aus einem Vertrag, einer Beziehung zu AMP IT oder den vorliegenden
                Nutzungsbedingungen ergeben oder damit im Zusammenhang stehen, von den am Sitz von AMP IT zuständigen
                Gerichten entschieden.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT SA
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Adresse: 1-3 Rue des Sablières, 1242 Satigny, Schweiz
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Telefon: +41 22 525 77 22
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                E-Mail: <a href="mailto:info@amp-it.ch">info@amp-it.ch</a>
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                UID: CHE-398.067.199
            </Typography>
        </Box>
    );
};
